/**
* @name: cell-content-show
* @author: weiyong
* @date: 2025-02-09 14:45
* @description：cell-content-show
* @update: 2025-02-09 14:45
*/
<template>
  <template v-if="groupFlag===true&&isNotSubCol">
<!--    向上合并 不需要显示 -->
    <span></span>
  </template>
  <template v-else>
    <!--    不向上合并 正常显示 -->
    <cell-content-show :column="column"  :cellContent="cellContent"/>
  </template>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "cell-content-show",
});
</script>

<script lang="ts" setup>
import CellContentShow from './cell-content-show.vue';

interface IProps {
  groupFlag:boolean;
  column: any,
  cellContent: any,
  showValFlag: boolean;
}

const props = withDefaults(defineProps<IProps>(), {
  column: {},
  groupFlag:false,
  cellContent: '',
  showValFlag: true,
})
const isNotSubCol=computed(()=>{
   if((props.column.dataIndex).indexOf("sub_")>=0){
      return  false;
   }
   return true;
})
</script>

<style type="text/css" lang="less">

</style>
